import globals from "@/util/global-whitelist.mjs";
import { StrictEventEmitter } from "@/util/strict-event-emitter.mjs";

export interface EventBusEvents {
  // Lets the event emitter take any type of event as a fallback, but if an event
  // is explicitly defined it will warn of type errors properly.
  [event: string]: (...args: unknown[]) => Promise<void> | void;
}

// This is intended to be a generic event bus where it wouldn't make sense
// to create more specific event emitters.
const eventBus = new StrictEventEmitter<EventBusEvents>();

globals.__BLITZ_DEV__.eventBus = eventBus;

export default eventBus;
